import React, {Component} from 'react';
import {connect} from "react-redux";
import {cancelSale} from "../../actions/AlertCancelSaleAction";
import {saleCanceled} from "../../actions/SaleCanceledAction";
import {showToast} from "../../actions/ToastAction";
import 'sweetalert/dist/sweetalert.css';
import {Button, Form, Modal} from "semantic-ui-react";
import SaleData from "../../data/SaleData";
const c = require("../../constants");

class CancelSaleAlert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            cancel_reason: '',
            return_products: false,
            cancel_type: 0
        }
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleChangeReturnProduct = () => this.setState((prevState) => ({ return_products: !prevState.return_products }))

    close(){
        this.setState({loading: false, cancel_reason:'', cancel_type:0, return_products:false})
        this.props.cancelSale({show:false, id:null})
    }

    cancel_order(){
        this.setState({loading: true})
        let data = {
            id:this.props.modal.id,
            cancel_reason: this.state.cancel_reason,
            return_products: this.state.return_products,
            cancel_type: this.state.cancel_type
        }
        SaleData.cancel(data, (res) => {
            if(res && res.update){
                this.props.showToast({message:'Venta anulada!', type:'success'});
                this.props.saleCanceled({canceled:true});
                this.close()
            }else{
                this.props.showToast({message:'Tenemos un problema, intentalo más tarde!', type:'error'});
            }
        });
    }

    render() {
        return (
            <Modal size='tiny' dimmer='inverted' open={this.props.modal.show} onClose={() => this.close()}>
                <Modal.Header>Anular Venta</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Form style={{textAlign: 'left'}} loading={this.state.loading}>
                            <Form.Select
                                label='Motivo de anulación'
                                name={'cancel_type'}
                                options={c.CANCEL_ORDER_TYPE}
                                placeholder='Motivo de anulación'
                                onChange={this.handleChange}
                                value={this.state.cancel_type}
                            />
                            <Form.TextArea
                                label='Observaciones'
                                name='cancel_reason'
                                placeholder='Observaciones'
                                value={this.state.cancel_reason}
                                onChange={this.handleChange}
                            />
                            <Form.Checkbox label='Devolver productos al inventario' onChange={this.handleChangeReturnProduct} name='return_products' checked={this.state.return_products}/>
                        </Form>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button icon='x' labelPosition='left' content="Cancelar" onClick={() => this.close()}/>
                    <Button primary loading={this.state.loading} disabled={this.state.loading} icon='save' labelPosition='left' content="Anular Venta" onClick={() => this.cancel_order()}/>
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('cancel_sale'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        cancelSale(data) {
            dispatch(cancelSale(data));
        },
        saleCanceled(data){
            dispatch(saleCanceled(data))
        },
        showToast(data){
            dispatch(showToast(data))
        }
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CancelSaleAlert)



// WEBPACK FOOTER //
// ./src/components/sale/CancelSaleAlert.js